<h2 mat-dialog-title translate>Course Description</h2>
<mat-dialog-content>
  <div>
    <table>
      <tr>
        <td class="divCellHeading" translate>Course Name</td>
        <td class="divCellContent">{{course}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>Course-Section</td>
        <td class="divCellContent">{{subjectSection}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>Teacher</td>
        <td class="divCellContent">{{teacher}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" translate>School</td>
        <td class="divCellContent">{{school}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" style="vertical-align:top;" translate>Curriculum</td>
        <td class="divCellContent">{{curriculum}}</td>
      </tr>
      <tr>
        <td class="divCellHeading" style="vertical-align:top;" translate>Description</td>
        <td class="divCellContent">{{description}}</td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <tyl-button style="float:right;" image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>
